// AI Questions Pool
const aiQuestions = [
  {
    id: 'ai_basic_1',
    question: '目前最热门的AI大语言模型不包括以下哪个？',
    options: ['ChatGPT', '豆包', 'Photoshop', '文心一言'],
    correctAnswer: 2,
    explanation: 'Photoshop是图像处理软件，不是AI大语言模型。',
    category: 'AI',
    difficulty: 'basic',
    type: 'theoretical',
  },
  {
    id: 'ai_basic_2',
    question: '以下哪项不是当前AI在医疗领域的热点应用？',
    options: ['医学影像诊断', '药物研发', '快递配送', '疾病预测'],
    correctAnswer: 2,
    explanation: '快递配送不属于AI在医疗领域应用。',
    category: 'AI',
    difficulty: 'basic',
    type: 'application',
  },
  {
    id: 'ai_basic_3',
    question: 'AI绘画成为热点，以下哪种不是常见的AI绘画工具？',
    options: ['Midjourney', 'StableDiffusion', '剪映', 'DALL-E'],
    correctAnswer: 2,
    explanation: '剪映是视频编辑软件，不是AI绘画工具。',
    category: 'AI',
    difficulty: 'basic',
    type: 'application',
  },
  {
    id: 'ai_basic_4',
    question: '2024年大火的AI视频生成工具是？',
    options: ['Runway', 'Adobe Premiere', 'Final Cut Pro', 'Audacity'],
    correctAnswer: 0,
    explanation: 'Runway是2024年流行的AI视频生成工具。',
    category: 'AI',
    difficulty: 'basic',
    type: 'application',
  },
  {
    id: 'ai_basic_5',
    question: 'AI是以下哪个英文短语的缩写？',
    options: [
      'Automatic Intelligence',
      'Artificial Intelligence',
      'Applied Intelligence',
      'Advanced Intelligence',
    ],
    correctAnswer: 1,
    explanation: 'AI即Artificial Intelligence，人工智能。',
    category: 'AI',
    difficulty: 'basic',
    type: 'theoretical',
  },
  {
    id: 'ai_basic_6',
    question: '神经网络是AI的重要技术基础，它模仿的是？',
    options: [
      '计算机硬件结构',
      '人类大脑神经元结构',
      '电路结构',
      '数学公式推导',
    ],
    correctAnswer: 1,
    explanation: '神经网络模仿人类大脑神经元结构。',
    category: 'AI',
    difficulty: 'basic',
    type: 'theoretical',
  },
  {
    id: 'ai_intermediate_1',
    question: '在机器学习中，监督学习的关键是？',
    options: [
      '有大量无标签数据',
      '有带标签的训练数据',
      '不需要数据',
      '数据随机生成',
    ],
    correctAnswer: 1,
    explanation: '监督学习依赖带标签训练数据。',
    category: 'AI',
    difficulty: 'intermediate',
    type: 'theoretical',
  },
  {
    id: 'ai_intermediate_2',
    question: '深度学习中，反向传播的主要作用是？',
    options: [
      '生成新数据',
      '计算网络层数',
      '调整神经网络的权重',
      '确定输入数据格式',
    ],
    correctAnswer: 2,
    explanation: '反向传播用于调整神经网络权重。',
    category: 'AI',
    difficulty: 'intermediate',
    type: 'theoretical',
  },
  {
    id: 'ai_intermediate_3',
    question: '以下哪个场景没有用到AI技术？',
    options: ['智能语音助手', '共享单车开锁', '智能推荐系统', '自动驾驶汽车'],
    correctAnswer: 1,
    explanation: '共享单车开锁主要基于物联网等技术，一般未直接用AI。',
    category: 'AI',
    difficulty: 'intermediate',
    type: 'application',
  },
  {
    id: 'ai_intermediate_4',
    question: 'AI在教育领域的应用不包括？',
    options: ['智能批改作业', '定制个性化学习方案', '建设校园', '虚拟助教'],
    correctAnswer: 2,
    explanation: '建设校园不属于AI在教育领域的应用。',
    category: 'AI',
    difficulty: 'intermediate',
    type: 'application',
  },
  {
    id: 'ai_advanced_1',
    question: '训练AI模型时，训练数据的作用是什么？',
    options: [
      '帮助模型学习规律',
      '增加硬件耗电量',
      '存储无关信息',
      '美化界面设计',
    ],
    correctAnswer: 0,
    explanation: '训练数据提供样本供模型学习特征与规律。',
    category: 'AI',
    difficulty: 'advanced',
    type: 'theoretical',
  },
  {
    id: 'ai_advanced_2',
    question: '过拟合现象是指模型出现什么情况？',
    options: [
      '过度适应训练数据，泛化能力差',
      '计算速度极快',
      '完全无法学习',
      '硬件故障',
    ],
    correctAnswer: 0,
    explanation: '过拟合模型在训练集表现好，但测试集效果差。',
    category: 'AI',
    difficulty: 'advanced',
    type: 'theoretical',
  },
  {
    id: 'ai_advanced_3',
    question: '电商平台的个性化推荐依赖哪种技术？',
    options: ['协同过滤算法', '机械臂操作', '传统纸质广告', '手写商品清单'],
    correctAnswer: 0,
    explanation: 'AI分析用户行为数据推荐感兴趣的商品。',
    category: 'AI',
    difficulty: 'advanced',
    type: 'application',
  },
  {
    id: 'ai_advanced_4',
    question: 'AI在医疗领域可辅助什么？',
    options: ['疾病诊断', '手术刀生产', '医院建筑装修', '药品运输车辆驾驶'],
    correctAnswer: 0,
    explanation: 'AI可通过医学影像分析帮助医生识别病灶。',
    category: 'AI',
    difficulty: 'advanced',
    type: 'application',
  },
  {
    id: 'ai_advanced_5',
    question: 'AI偏见问题通常源于什么？',
    options: [
      '训练数据中的不公平样本',
      '计算机颜色显示',
      '硬件散热性能',
      '键盘鼠标品牌',
    ],
    correctAnswer: 0,
    explanation: '数据若包含性别、种族偏见，AI会学习并放大。',
    category: 'AI',
    difficulty: 'advanced',
    type: 'theoretical',
  },
] as const;

// Web3 Questions Pool
const web3Questions = [
  {
    id: 'web3_basic_1',
    question: '以下哪个不是区块链的特点？',
    options: ['去中心化', '不可篡改', '数据可随意删除', '透明公开'],
    correctAnswer: 2,
    explanation: '区块链的数据一旦写入就不能删除，这是其重要特征。',
    category: 'Web3',
    difficulty: 'basic',
    type: 'theoretical',
  },
  {
    id: 'web3_basic_2',
    question: '比特币网络使用的是什么共识机制？',
    options: [
      'PoW工作量证明',
      'PoS权益证明',
      'DPoS委托权益证明',
      'PoA权威证明',
    ],
    correctAnswer: 0,
    explanation: '比特币使用PoW（工作量证明）机制实现共识。',
    category: 'Web3',
    difficulty: 'basic',
    type: 'theoretical',
  },
  {
    id: 'web3_basic_3',
    question: '智能合约主要在哪个平台上运行？',
    options: ['以太坊', 'Windows', 'Android', 'iOS'],
    correctAnswer: 0,
    explanation: '以太坊是最主要的智能合约平台。',
    category: 'Web3',
    difficulty: 'basic',
    type: 'application',
  },
  {
    id: 'web3_basic_4',
    question: 'Web3.0的核心特征不包括？',
    options: ['去中心化', '通过中心化服务器访问', '用户数据主权', '价值互联网'],
    correctAnswer: 1,
    explanation: 'Web3.0强调去中心化，不依赖中心化服务器。',
    category: 'Web3',
    difficulty: 'basic',
    type: 'theoretical',
  },
  {
    id: 'web3_basic_5',
    question: '以下哪个不是常见的数字钱包？',
    options: ['MetaMask', 'Word', 'Trust Wallet', 'TokenPocket'],
    correctAnswer: 1,
    explanation: 'Word是文字处理软件，不是数字钱包。',
    category: 'Web3',
    difficulty: 'basic',
    type: 'application',
  },
  {
    id: 'web3_intermediate_1',
    question: 'NFT的全称是？',
    options: [
      'New File Type',
      'Non-Fungible Token',
      'Network File Transfer',
      'New Financial Technology',
    ],
    correctAnswer: 1,
    explanation: 'NFT是Non-Fungible Token（非同质化代币）的缩写。',
    category: 'Web3',
    difficulty: 'intermediate',
    type: 'theoretical',
  },
  {
    id: 'web3_intermediate_2',
    question: '以下哪个不是DeFi（去中心化金融）的应用？',
    options: ['去中心化交易所', '流动性挖矿', '传统银行存款', '闪电贷'],
    correctAnswer: 2,
    explanation: '传统银行存款是中心化金融的业务。',
    category: 'Web3',
    difficulty: 'intermediate',
    type: 'application',
  },
  {
    id: 'web3_intermediate_3',
    question: '以下哪个不是主流的区块链编程语言？',
    options: ['Solidity', 'HTML', 'Rust', 'Move'],
    correctAnswer: 1,
    explanation: 'HTML是网页标记语言，不是区块链编程语言。',
    category: 'Web3',
    difficulty: 'intermediate',
    type: 'theoretical',
  },
  {
    id: 'web3_intermediate_4',
    question: 'DAO是什么的缩写？',
    options: [
      'Decentralized Autonomous Organization',
      'Digital Asset Option',
      'Data Access Object',
      'Direct Access Operation',
    ],
    correctAnswer: 0,
    explanation:
      'DAO是Decentralized Autonomous Organization（去中心化自治组织）的缩写。',
    category: 'Web3',
    difficulty: 'intermediate',
    type: 'theoretical',
  },
  {
    id: 'web3_advanced_1',
    question: '以下哪个不是Layer 2扩容解决方案？',
    options: ['Optimistic Rollup', 'ZK Rollup', 'HTTP Protocol', 'Plasma'],
    correctAnswer: 2,
    explanation: 'HTTP是网络协议，不是区块链扩容解决方案。',
    category: 'Web3',
    difficulty: 'advanced',
    type: 'theoretical',
  },
  {
    id: 'web3_advanced_2',
    question: '闪电网络主要解决什么问题？',
    options: ['比特币扩容', '智能合约执行', '挖矿难度', '网络延迟'],
    correctAnswer: 0,
    explanation: '闪电网络是比特币的Layer 2扩容解决方案。',
    category: 'Web3',
    difficulty: 'advanced',
    type: 'theoretical',
  },
  {
    id: 'web3_advanced_3',
    question: '以下哪个不是常见的区块链共识机制？',
    options: ['PoW', 'PoS', 'HTTPS', 'DPoS'],
    correctAnswer: 2,
    explanation: 'HTTPS是安全传输协议，不是共识机制。',
    category: 'Web3',
    difficulty: 'advanced',
    type: 'theoretical',
  },
  {
    id: 'web3_advanced_4',
    question: '智能合约的特点不包括？',
    options: ['自动执行', '可随意修改', '去中心化', '透明公开'],
    correctAnswer: 1,
    explanation: '智能合约一旦部署就不能修改，这是其重要特征。',
    category: 'Web3',
    difficulty: 'advanced',
    type: 'theoretical',
  },
  {
    id: 'web3_advanced_5',
    question: 'Web3项目方最常用的融资方式是？',
    options: ['ICO', '银行贷款', '股票上市', '民间借贷'],
    correctAnswer: 0,
    explanation: 'ICO（首次代币发行）是Web3项目最常用的融资方式。',
    category: 'Web3',
    difficulty: 'advanced',
    type: 'application',
  },
] as const;

// AI + Web3 Combined Questions Pool
const combinedQuestions = [
  {
    id: 'combined_1',
    question: '区块链在AI训练数据验证中的作用类似于？',
    options: [
      '加速快递运输的调度员',
      '防止比赛作弊的公正裁判',
      '美化照片的滤镜软件',
      '降低电费的节能设备',
    ],
    correctAnswer: 1,
    explanation: '区块链在AI训练数据验证中起到公正验证的作用。',
    category: 'Web3',
    difficulty: 'advanced',
    type: 'application',
  },
  {
    id: 'combined_2',
    question: 'AI在区块链中的主要应用不包括？',
    options: ['智能合约优化', '交易模式分析', '实体店铺装修', '安全风险预测'],
    correctAnswer: 2,
    explanation: '实体店铺装修与AI和区块链技术无关。',
    category: 'both',
    difficulty: 'advanced',
    type: 'application',
  },
  {
    id: 'combined_3',
    question: 'Web3和AI结合的应用场景不包括？',
    options: [
      '去中心化AI训练',
      '数据隐私保护',
      '传统银行柜台服务',
      '智能合约自动化',
    ],
    correctAnswer: 2,
    explanation: '传统银行柜台服务不涉及Web3和AI技术的结合。',
    category: 'both',
    difficulty: 'advanced',
    type: 'application',
  },
  {
    id: 'combined_4',
    question: 'AI在区块链安全中的作用是？',
    options: ['识别异常交易', '清洁矿场设备', '打印区块信息', '搬运矿机'],
    correctAnswer: 0,
    explanation: 'AI可以通过分析交易模式识别异常交易。',
    category: 'both',
    difficulty: 'advanced',
    type: 'application',
  },
  {
    id: 'combined_5',
    question: '去中心化AI的优势不包括？',
    options: ['数据隐私保护', '训练成本降低', '实体店面选址', '模型共享激励'],
    correctAnswer: 2,
    explanation: '实体店面选址不是去中心化AI的优势。',
    category: 'both',
    difficulty: 'advanced',
    type: 'theoretical',
  },
];

// 获取随机题目
export function getRandomQuestions(
  category: 'AI' | 'Web3' | 'both',
  count: number
) {
  const shuffle = (array: any[]) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  let questionPool = [];
  if (category === 'AI') {
    questionPool = [...aiQuestions];
  } else if (category === 'Web3') {
    questionPool = [...web3Questions];
  } else {
    // For 'both' category, include AI, Web3, and combined questions
    questionPool = [...aiQuestions, ...web3Questions, ...combinedQuestions];
  }

  return shuffle(questionPool).slice(0, count);
}

// 获取题目数量
export function getQuestionCount(category: 'AI' | 'Web3' | 'both'): number {
  switch (category) {
    case 'AI':
      return 15;
    case 'Web3':
      return 15;
    case 'both':
      return 20;
    default:
      return 15;
  }
}

// 获取等级描述
export function getLevelDescription(score: number): string {
  if (score >= 80) {
    return '专家级：您展现出了深厚的专业知识储备，已经达到行业专家水平。';
  } else if (score >= 60) {
    return '进阶级：您具备扎实的基础知识，正在向专业水平迈进。';
  } else if (score >= 40) {
    return '入门级：您已经开始了解这个领域，还需要进一步学习和实践。';
  } else {
    return '小白级：您可能对这个领域很感兴趣，但还处于一问三不知的阶段。';
  }
}

// 获取建议
export function getSuggestions(
  score: number,
  category: 'AI' | 'Web3' | 'both'
): string[] {
  const suggestions: string[] = [];

  if (category === 'AI' || category === 'both') {
    if (score >= 80) {
      suggestions.push(
        "推荐参加我们的'AI架构师培训'，提升系统设计能力",
        '加入AI高级技术研讨群，与行业专家交流前沿技术',
        '参与我们的企业级AI项目实战营'
      );
    } else if (score >= 60) {
      suggestions.push(
        "推荐参加我们的'AI实战训练营'，通过实际项目提升实践能力",
        '订阅我们的AI技术周刊，及时了解行业动态',
        '加入AI技术交流社群，与同行交流学习'
      );
    } else {
      suggestions.push(
        "建议参加我们的'AI基础夯实课程'，打好理论基础",
        '订阅我们的AI入门指南，循序渐进学习',
        '加入AI新手交流群，与伙伴一起成长'
      );
    }
  }

  if (category === 'Web3' || category === 'both') {
    if (score >= 80) {
      suggestions.push(
        "邀请加入我们的'AIGC-DAO共创联盟'，参与AI+Web3项目",
        '投资数字与实体经济结合的广告屏RWA项目',
        '加入AIGC-DAO交流群，深度交流'
      );
    } else if (score >= 60) {
      suggestions.push(
        "推荐参加'Web3入门实践计划'，提升理论和应用技能",
        '加入Web3项目实战营，积累实际经验',
        '了解Web3及行业相关热点，持续学习'
      );
    } else {
      suggestions.push(
        "建议参加'Web3基础知识课程'，系统学习",
        '加入AIGC-DAO交流群，寻找学习伙伴',
        '订阅我们的Web3防骗指南，打好基础'
      );
    }
  }

  return suggestions;
}

export type { Question } from '../types';
export { aiQuestions, web3Questions, combinedQuestions };
